import { select } from "d3-selection"
import { Component } from "react"
import PropTypes from "prop-types"

class Axis extends Component {
  static propTypes = {
    fn: PropTypes.func.isRequired,
    transform: PropTypes.string.isRequired,
  }

  draw = () => {
    const { ref, props: { fn } } = this

    select(ref)
      .call(fn)
  }

  componentDidUpdate() {
    this.draw()
  }

  setRef = node => {
    this.ref = node
    this.draw()
  }

  render() {
    const { transform } = this.props
    return <g ref={this.setRef} className="axis" transform={transform} />
  }
}

export default Axis
